export const exclusionMessage = "Select product type not elligible for POS/Zone ( If Any )";
export const exclusionSlotMessage = "Product type excluded for delivery from POS/Zone";
export const subExclusionMessage = "Please note: All product type are marked as elligible by default.";

export const NO_DATA_PRESENT_ERROR = "No data found for.";
export const ALL_RESULTS_FILTERED = "All results filtered.";
export const PLEASE_RESET_TRY_AGAIN = "Please reset filters and try again";
export const PLEASE_CLEAR_ALL_FILTERS_TRY_AGAIN = "Please reset your criteria and try again";
